import React from 'react';
import ManualPayoutsPanel from '@/features/shared/components/ManualPayoutsPanel';

const DesktopPayoutsPage = () => {
  return (
    <main className="w-full h-full p-6 max-w-7xl mx-auto">
      <ManualPayoutsPanel compact={false} />
    </main>
  );
};

export default DesktopPayoutsPage;

